import React from 'react';
import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';
import DateField from '@molecules/BEDatePicker/DateField';
import DatePicker from '@molecules/BEDatePicker';

const DemoDatePicker = () => {
  const localeList: string[] = ['en', 'pt-BR', 'ja-JP', 'ar-KW'];
  const now = new Date();

  return (
    <Box>
      <h2>DatePicker</h2>
      {localeList.map((locale, langIndex) => (
        <div key={langIndex}>
          <Divider m={2} />
          <Flex align={'center'}>
            <p>Date {locale}</p>
            <Spacer />
            <Box>
              <DateField locale={locale} date={now} />
            </Box>
          </Flex>
        </div>
      ))}

      <Divider m={2} />
      <Flex align={'center'}>
        <p>Date selected</p>
        <Spacer />
        <Box>
          <DateField selected={true} date={now} />
        </Box>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>DatePicker</p>
        <Spacer />
        <Box>
          <DatePicker />
        </Box>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>DatePicker md</p>
        <Spacer />
        <Box>
          <DatePicker size="md" />
        </Box>
      </Flex>
    </Box>
  );
};

export default DemoDatePicker;
